/**
 * External Dependencies
 */
import { get } from 'lodash';

/**
 * Internal Dependencies
 */
import getCubeMeta from './get-cube-meta';

export default (state) => {
	return get(getCubeMeta(state), ['cubes'], []);
};
